export default __webpack_public_path__ + "static/media/265.340932a3.jpg";